import axios from '../utils/request.js';
import { createFormDataList } from '../utils/fileRequest'
let timer = null;

export default {
    SetSuperviseDetailListData({ commit, state }) {
        state.superViseDetailListData = selectedDetailRows;
    },
    UPLOAD({ commit, state, dispatch }, { url, event, path,operation,uploadNewFileName, cb, query = {}, mkdirRequestUrl }) {
    // UPLOAD({ commit, state, dispatch }, { url, event, path,operation,uploadNewFileName, cb, query = {}, mkdirRequestUrl }) {
        // 如果之前显示过弹窗，还没过5秒，关闭定时器
        timer && clearTimeout(timer)
        /* 
            url: 上传文件路径，
            event: input:type='file'元素
            path: 将保存的服务器文件路径
            cb: 回调
            query: 请求参数
            mkdirRequestUrl: 创建文件夹请求接口
        */
        createFormDataList(event, path, mkdirRequestUrl,operation,uploadNewFileName).then(list => {
            /*
                经过处理的所选文件列表，格式为： 
                [{
                    formData: FormData, // 最终请求发送的数据
                    name: file.name,  // 文件名
                    status: 'UPLOAD_STOP', // 上传状态 UPLOAD_STOP:暂停， UPLOAD_COMPLETE: 成功 UPLOAD_ING: 上传中
                    process: 0, //进度 100分制
                    size: file.size  // 文件大小
                }]
            */
            if (state.uploadList.length) {
                list = state.uploadList.concat(list)
            }
            commit('SET_UPLOAD_LIST', list) // 赋值到store
            commit('TOGGLE_UPLOAD_DIALOG', true) // 显示弹窗
            dispatch('UPLOAD_REQUEST', { index: 0, cb, url, query }) // 正式发起请求
        })
    },
    UPLOAD_REQUEST({ dispatch, commit, state }, { index, cb, url, query }) {
        /* 
            index: 当前上传第index个
            cb: 回调
            query: 请求参数
            url: 上传文件路径，
        */
        state.uploadList[index].status = 'UPLOAD_ING' // 将当前文件状态设置为上传中
        if(query.projectId) {
            state.uploadList[index].formData.delete('projectId')
            state.uploadList[index].formData.append('projectId', query.projectId)
        }
        // 正式发起请求
        axios.post(url, state.uploadList[index].formData, {
            onUploadProgress(e) {
                // console.log(Math.floor(e.loaded / e.total * 100))
                commit('CHANGE_UPLOAD_ITEM_PROCESS', { index, process: Math.floor(e.loaded / e.total *100) })
                // state.uploadList[index].process = Math.floor(e.loaded / e.total)
            }
        }).then(res => {
            state.uploadList[index].status = res.data.success ? 'UPLOAD_COMPLETE' : 'UPLOAD_FAIL';
            if (index < state.uploadList.length - 1) {
                // 还有没上传的文件，继续上传 index + 1
                dispatch('UPLOAD_REQUEST', { index: index + 1, cb, url, query })
            }
            else {
                // 上传完毕，调用回调函数，隔5秒后关闭弹窗
                cb && cb()
                timer = setTimeout(function () {
                    commit('TOGGLE_UPLOAD_DIALOG', false)
                    commit('SET_UPLOAD_LIST', [])
                }, 5000)
            }
        })
    },
    GET_USER_MENU({ commit }) {
        return new Promise((resolve, reject) => {
            axios.post('/menu/getUserMenuListTree').then(res => {
                
                
                if(res && res.data && res.data.success){
                    let list = ['/noPermission', '/login', '/workPlat'];
                    list = list.concat(res.data.result.map(item => item.menuUrl))
                    // console.log('用户权限：' + list)
                    commit('SET_USER_MENU', list)
                    commit('SET_ORIGIN_USER_MENU', res.data.result)
                    resolve()
                }
            })
        })
    }
};
